module.exports = __webpack_public_path__ + "img/logo.d480902c.svg";